import CLC2UniHomePage from "./CLC2UniHomePage";

export default CLC2UniHomePage;
